import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import SiteNav from "./components/SiteNav";
import SiteFooter from "./components/SiteFooter";
import Home from "./pages/Home";
import Hikes from "./pages/Hikes";
import HikeDetail from "./pages/HikeDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminHikes from "./pages/AdminHikes";
import WaiverPage from "./pages/WaiverPage";
import { MessageCircle } from "lucide-react";

function ScrollReset() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="grain min-h-screen bg-paper">
      <ScrollReset />
      {!isAdmin && <SiteNav />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hikes" element={<Hikes />} />
        <Route path="/hikes/:slug" element={<HikeDetail />} />
        <Route path="/waiver/:token" element={<WaiverPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/hikes" element={<AdminHikes />} />
      </Routes>
      {!isAdmin && <SiteFooter />}
      {!isAdmin && (
        <a
          href="https://wa.me/306983267064?text=Kalimera%20Vasilis%2C%20I%27d%20like%20to%20ask%20about%20a%20hike"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float"
          aria-label="Chat with Vasilis on WhatsApp"
          className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl transition-transform duration-300 hover:-translate-y-1"
        >
          <MessageCircle size={26} />
        </a>
      )}
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    return () => lenis.destroy();
  }, []);

  return (
    <BrowserRouter>
      <Shell />
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
